<template>
    <div class="chartDialog">
        <div v-if="showZhe" id="myChart2" :style="{width: '100%', height: '100%'}"></div>
        <div v-if="showBing" id="myChart3" :style="{width: '100%', height: '100%'}"></div>
        <div v-if="showZhu" id="myChart1" :style="{width: '100%', height: '100%'}"></div>
        <div v-if="noDataVisible" id="noDataChart">{{ chartData.noDataTips }}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showZhu:false,
                showZhe:false,
                showBing:true,
                noDataVisible: false,
                defaultColor: ['#5470C6','#91CC75','#FC8452','#73C0DE','#3BA272','#EE6666','#9A60B4','#EA7CCC','#FAC858'],
            }
        },
        props: {
            chartData: {
                type: Object,
                default () {
                    return null;
                },
            },
            chartType: {
                type: String,
                default () {
                    return null;
                }
            },
        },
        //inject:['transMethod'],
        methods: {
            childMethod(id) {
                this.chartData.methodstr(id);
                // if(this.transMethod){
                //     this.transMethod();
                // }
            },
            drawLine(){
                this.chartTitle = this.chartData.title;
                // 基于准备好的dom，初始化echarts实例
                if(this.chartType=="zhu"){
                    let myChart1 = this.$echarts.init(document.getElementById('myChart1'));
                    const yInfo=[];
                    if(this.chartData.yDataDirect=="horizontal"){
                        for(var i=0;i<this.chartData.yData.length;i++){
                            yInfo.push(this.chartData.yData[i]);
                        }
                    }else{
                        for(var i=0;i<this.chartData.yData.length;i++){
                            yInfo.push(this.chartData.yData[i].split("").join("\n"));
                        }
                    }

                    myChart1.setOption({
                        color: [this.chartData.color], //柱体颜色
                        title: {
                            text: this.chartData.title,
                            subtext: this.chartData.subtitle,
                            textStyle: {//主标题的属性
                              color: '#C28D21',//颜色
                              fontSize: 24,//大小
                              fontWeight: '700',//粗细
                            },
                            subtextStyle: {//副标题的属性
                              color: '#25664A',
                              fontSize: 12,//大小
                              // 同主标题
                            },
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow',
                                label: {
                                    show: true
                                }
                            }
                        },
                        toolbox: {
                            show: this.chartData.showFeature,
                            orient: 'horizontal',
                            left: 'right',
                            top: 'top',
                            feature: {
                                mark: {show: true},
                                //dataView: {show: true, readOnly: false},
                                //magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                                magicType: {show: true, type: ['line', 'bar']},
                                saveAsImage: {show: true},
                                restore: {show: true},
                            }
                        },
                        calculable: true,
                        xAxis: {
                            type: 'category',
                            data: yInfo
                        },
                        yAxis: {type: 'value'},
                        dataZoom: [
                            {type: 'inside'}
                        ],
                        // visualMap: {//视觉映射
                        //     type: 'continuous',
                        //     dimension: 1,
                        //     text: ['High', 'Low'],
                        //     inverse: true,
                        //     itemHeight: 180,
                        //     calculable: true,
                        //     min: 0,
                        //     max: 100,
                        //     top: 60,
                        //     left: 0,
                        //     inRange: {
                        //         colorLightness: [0.8, 0.4]
                        //     },
                        //     outOfRange: {
                        //         color: '#bbb'
                        //     },
                        //     controller: {
                        //         inRange: {
                        //             color: '#36a0f1'
                        //         }
                        //     }
                        // },
                        series: [{
                            name: this.chartData.yTitle+' / '+this.chartData.xTitle,
                            type: 'bar',
                            data: this.chartData.xData
                        }],
                        animationDelay: function (idx) {//动态延迟
                            return idx * 30;
                        },
                        animationEasing: 'elasticOut',
                        animationDelayUpdate: function (idx) {
                            return idx * 5;
                        }

                    });

                    // Enable data zoom when user click bar. 缩放
                    var yMax = 100;
                    var dataShadow = [];
                    for (var i = 0; i < this.chartData.xData.length; i++) {
                        dataShadow.push(yMax);
                    }
                    var zoomSize = 6;

                    myChart1.on('click', function (params) {
                        childMethod(params.dataIndex);

                        // console.log(dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)]);
                        // myChart1.dispatchAction({
                        //     type: 'dataZoom',
                        //     startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
                        //     endValue: dataAxis[Math.min(params.dataIndex + zoomSize / 2, dataInfo.length - 1)]
                        // });
                    });
                }else if(this.chartType=="zhe"){
                    let myChart2 = this.$echarts.init(document.getElementById('myChart2'));
                    const yInfo=[];
                    if(this.chartData.yDataDirect=="horizontal"){
                        for(var i=0;i<this.chartData.yData.length;i++){
                            yInfo.push(this.chartData.yData[i]);
                        }
                    }else{
                        for(var i=0;i<this.chartData.yData.length;i++){
                            yInfo.push(this.chartData.yData[i].split("").join("\n"));
                        }
                    }

                    myChart2.setOption({
                        title: {
                            text: this.chartData.title,
                            subtext: this.chartData.subtitle,
                            textStyle: {//主标题的属性
                              color: '#C28D21',//颜色
                              fontSize: 24,//大小
                              fontWeight: '700',//粗细
                            },
                            subtextStyle: {//副标题的属性
                              color: '#25664A',
                              fontSize: 12,//大小
                              // 同主标题
                            },
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        toolbox: {
                            show: this.chartData.showFeature,
                            orient: 'horizontal',
                            left: 'right',
                            top: 'top',
                            feature: {
                                mark: {show: true},
                                //dataView: {show: true, readOnly: false},
                                //magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                                magicType: {show: true, type: ['line', 'bar']},
                                saveAsImage: {show: true},
                                restore: {show: true},
                            }
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: yInfo
                        },
                        yAxis: {
                            type: 'value',
                            boundaryGap: ["0","0"],
                        },
                        dataZoom: [
                            {type: 'inside'}
                        ],
                        series: [{
                            name:this.chartData.xTitle,
                            type:'line',
                            data: this.chartData.xData,
                            markPoint: {
                                data: [
                                    {type: 'max', name: '最大值'},
                                    {type: 'min', name: '最小值'}
                                ]
                            },
                            markLine: {
                                data: [
                                    {type: 'average', name: '平均值'}
                                ]
                            },
                            itemStyle: {
                                normal: {
                                    color: this.chartData.color,
                                    borderColor: '#fff',
                                    borderWidth: 1,
                                    borderType: 'solid',
                                    shadowColor: '#fff',
                                    shadowBlur: 4,
                                },
                            },
                            // lineStyle: { //折线颜色不取渐变色，取color设置值
                            //     normal: {
                            //         width: 4,
                            //         color: {
                            //             type: 'linear',
                            //             x: 0,
                            //             y: 0,
                            //             x2: 1, //从左到右
                            //             y2: 0,
                            //             colorStops: [{
                            //                 offset: 0,
                            //                 color: 'rgba(255,142,31,1)' // 0% 处的颜色
                            //             }, {
                            //                 offset: 1,
                            //                 color: 'rgba(255,142,31,1)' // 100% 处的颜色
                            //             }],
                            //             globalCoord: false // 缺省为 false
                            //         }
                            //     }
                            // },
                            // areaStyle: { //折线颜色不取渐变色，取color设置值
                            //     normal: {
                            //         color: {
                            //             type: 'linear',
                            //             x: 0,
                            //             y: 0,
                            //             x2: 1, //从左到右，但不能从上到下，需要借助辅助系列
                            //             y2: 0,
                            //             colorStops: [{
                            //                 offset: 0,
                            //                 color: 'rgba(255,142,31,1)' // 0% 处的颜色
                            //             }, {
                            //                 offset: 1,
                            //                 color: 'rgba(255, 142, 31, 1)' // 100% 处的颜色
                            //             }],
                            //             globalCoord: false // 缺省为 false
                            //         }
                            //     }
                            // },
                        }]
                    });

                    myChart2.on('click', function (params) {
                        childMethod(params.dataIndex);
                    });
                }else if(this.chartType=="bing"){
                    if(this.chartData.xData.length == 0 || this.chartData.yData.length == 0){
                        this.pieChartVisible = false;
                        this.noDataVisible = true;
                    }else{
                        let myChart3 = this.$echarts.init(document.getElementById('myChart3'));
                        let size = this.chartData.yData.length;
                        let seriesData = [];
                        let selected = {};
                        for (let i=0;i<size;i++){
                            seriesData.push({
                                name: this.chartData.yData[i],
                                value: this.chartData.xData[i]
                            });
                            selected[i] = true;
                        }
                        myChart3.setOption({
                            //color: this.handleLineColor(),
                            title: {
                                text: this.chartData.title,
                                subtext: this.chartData.subtitle,
                                textStyle: {//主标题的属性
                                  color: '#C28D21',//颜色
                                  fontSize: 24,//大小
                                  fontWeight: '700',//粗细
                                },
                                subtextStyle: {//副标题的属性
                                  color: '#25664A',
                                  fontSize: 12,//大小
                                  // 同主标题
                                },
                                x:'center'
                            },
                            tooltip : {
                                trigger: 'item',
                                formatter: "{a} <br/>{b} : {c} ({d}%)"
                            },
                            toolbox: {
                                show: this.chartData.showFeature,
                                orient: 'horizontal',
                                left: 'right',
                                top: 'top',
                                feature: {
                                    mark: {show: true},
                                    saveAsImage: {show: true},
                                    restore: {show: true},
                                }
                            },
                            legend: {
                                type: 'scroll',
                                orient: 'vertical',
                                right: 100,
                                top: 20,
                                bottom: 10,
                                data: this.chartData.yData,
                                selected: selected
                            },
                            //百分比
                            label: {
                                normal: {
                                    show: true,
                                    formatter: '{b}: {c}({d}%)' //自定义显示格式(b:name, c:value, d:百分比)
                                }
                            },
                            series : [
                                {
                                    name: this.chartData.yTitle+" / "+this.chartData.xTitle+"( 比例 )",
                                    type: 'pie',
                                    radius : '60%',
                                    center: ['40%', '60%'],
                                    data: seriesData,
                                    itemStyle: {
                                        emphasis: {
                                            shadowBlur: 10,
                                            shadowOffsetX: 0,
                                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                                        }
                                    }
                                }
                            ]
                        });

                        myChart3.on('click', function (params) {
                            childMethod(params.dataIndex);
                        });
                    }
                }
            },
        },
        handleLineColor(){
            let color = this.chartData.color;

            if(color == null){
                color = [];

                this.chartData.legend.forEach((value, index) => {
                    color.push(this.defaultColor[index%this.defaultColor.length]);
                });
            }

            return color;
        },
        mounted() {
            if(this.chartType=="zhu"){
                this.showZhe = false;
                this.showBing = false;
            }else if(this.chartType=="zhe"){
                this.showzhu = false;
                this.showBing = false;
            }else if(this.chartType=="bing"){
                this.showzhu = false;
                this.showZhe = false;
            }
            this.drawLine();
            window.childMethod = this.childMethod;    // 方法赋值给window
        },
        watch:{
            chartData(newValue, oldValue) {
                this.chartData = newValue;
                this.drawLine();
            }
        }
    }
</script>

<style>
    .chartDialog{
        width: 100%;
        height: 100%;
    }

    #noDataChart {
        width: 100%;
        position: absolute;
        top: 0;
        margin-top: 300px;
        font-size: 24px;
        font-weight: bold;
        color: '#8a8e91';
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// pieChart.vue?534e7c17